exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2r_4Ht0h-Y13QI7V_D76Qz {\n  margin-top: -50px;\n  margin-bottom: 20px;\n}\n._2r_4Ht0h-Y13QI7V_D76Qz .dnn-suggestion .rw-popup-container .rw-list-option {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);

// Exports
exports.locals = {
	"permissionGrid": "_2r_4Ht0h-Y13QI7V_D76Qz"
};